import Button from "~/components/mantine/button/Button";
import { AlertCard } from "~/components/ui/card/AlertCard";
import PendingStatus from "~/components/ui/pendingStatus/PendingStatus";

import { useCardDialog } from "./useCardDialog";

type Props = {
  title: string;
  // What the card opens here.
  content: string;
  className?: string;
};

/**
 * In place of something an Autopto trial gets with a card (its own domain,
 * more sites): the admin opens the card dialog from here, a member is sent
 * to the admin.
 */
const CardRequiredAlert = ({ title, content, className }: Props) => {
  const { canAddCard, openCardDialog, isOpeningCardDialog, isAwaitingCard } =
    useCardDialog();

  return (
    <AlertCard
      type="neutral"
      title={title}
      className={className}
      content={
        canAddCard
          ? `${content} You pay $0 today, and your trial continues.`
          : `${content} Ask your team admin to add a card.`
      }
      actions={
        canAddCard &&
        (isAwaitingCard ? (
          <PendingStatus>Activating your platform…</PendingStatus>
        ) : (
          <Button onClick={openCardDialog} loading={isOpeningCardDialog}>
            Launch My Platform
          </Button>
        ))
      }
    />
  );
};

export default CardRequiredAlert;
